import { Fragment, useContext, useEffect, useRef } from 'react'
import { SocketContext } from '../../context/socket'
import { Link } from 'react-router-dom'
import { appGetAllDashboard } from '../../store/dashboard'
import { useDispatch, useSelector } from 'react-redux'

function Dashboard() {
	const socket = useContext(SocketContext)
	const dispatch = useDispatch()
	const dashboard = useSelector(state => state?.dashboardReducer.dashboard)

	useEffect(() => {
		socket.connect()
		dispatch(appGetAllDashboard())
	}, [])

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading">
					<div className="d-flex align-items-center">
						<div className="mr-auto">
							<div className="">Dashboard</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row m-3">
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-warning-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Sanstha</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-building fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-4">
									<Link to="/sanstha" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.sansthaCount || 0}</div>
										<div className="small h5">Total</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/sanstha"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.sansthaActivating > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.sansthaActivating || 0}
										</div>
										<div className="small h5">To be activated</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/sanstha"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.sansthaVerifying > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.sansthaVerifying || 0}
										</div>
										<div className="small h5">To be verified</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<Link to="/user" style={{ textDecoration: 'none' }}>
						<div className="dashboard-card bg-pink-light h-100" style={{ minHeight: '160px' }}>
							<div className="card-body h-100 d-flex flex-column justify-content-between">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										<div className="h2 mb-0">{dashboard?.userCount || 0}</div>
										<div className="text-uppercase font-weight-bold">Users</div>
										<span className="text-white">Registered users</span>
									</div>
									<div className="icon-wrapper">
										<em className="icon-user fa-2x"></em>
									</div>
								</div>
							</div>
						</div>
					</Link>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<Link to="/payment-history" style={{ textDecoration: 'none' }}>
						<div className="dashboard-card bg-warning-light h-100" style={{ minHeight: '160px' }}>
							<div className="card-body h-100 d-flex flex-column justify-content-between">
								<div className="d-flex align-items-center">
									<div className="flex-grow-1">
										<div className="h2 mb-0">₹{dashboard?.totalFund || 0}</div>
										<div className="text-uppercase font-weight-bold">Total Fund</div>
										<span className="text-white">Total Fund</span>
									</div>
									<div className="icon-wrapper">
										<em className="icon-badge fa-2x"></em>
									</div>
								</div>
							</div>
						</div>
					</Link>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-purple h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Event</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-calendar-alt fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-4">
									<Link to="/event" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.event || 0}</div>
										<div className="small h5">Total</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/event-booking"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.eventBookingCount > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.eventBookingCount || 0}
										</div>
										<div className="small h5">Booking</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/boli-booking"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.boliBookingcount > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.boliBookingcount || 0}
										</div>
										<div className="small h5">Boli</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row m-3">
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-info-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Post</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-edit fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link to="/post" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.post || 0}</div>
										<div className="small h5">Total</div>
									</Link>
								</div>

								<div className="col-6">
									<Link
										to="/post"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.postapprovalCountNumber > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.postapprovalCountNumber || 0}
										</div>
										<div className="small h5">Approval</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-green-light h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Social Project</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-project-diagram fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link
										to="/social-project"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">{dashboard?.socialproject || 0}</div>
										<div className="small h5">Projects</div>
									</Link>
								</div>

								<div className="col-6">
									<Link
										to="/socialproject-donation"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.socialprojectbooking > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.socialprojectbooking || 0}
										</div>
										<div className="small h5">Booking</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-dark h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Contribution</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-hand-holding-heart fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-6">
									<Link to="/contribution" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.contribution || 0}</div>
										<div className="small h5">Total Contribution</div>
									</Link>
								</div>

								<div className="col-6">
									<Link
										to="/requsteduser"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.usersWaiting > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">{dashboard?.usersWaiting || 0}</div>
										<div className="small h5">Membership Approval</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6 col-md-12 mb-4">
					<div className="dashboard-card bg-success h-100" style={{ minHeight: '160px' }}>
						<div className="card-body h-100 d-flex flex-column justify-content-between">
							<div className="d-flex justify-content-between align-items-center mb-2">
								<div className="text-uppercase font-weight-bold text-white">Support & Service</div>
								<div className="icon-wrapper text-white">
									<em className="fas fa-headset fa-lg"></em>
								</div>
							</div>

							<div className="row text-center g-0">
								<div className="col-4">
									<Link to="/sponsor" className="d-block text-white text-decoration-none px-1">
										<div className="h3 mb-1 font-weight-bold">{dashboard?.sponsorCount || 0}</div>
										<div className="small h5">Sponsor</div>
									</Link>
								</div>
								<div className="col-4">
									<Link
										to="/facility-booking"
										className="d-block text-white text-decoration-none px-1"
									>
										<div className="h3 mb-1 font-weight-bold">
											{dashboard?.facilityBooking || 0}
										</div>
										<div className="small h5">Facility</div>
									</Link>
								</div>

								<div className="col-4">
									<Link
										to="/help"
										className={`d-block text-decoration-none px-1 ${
											dashboard?.helpdesk > 0 ? 'text-white' : 'text-white'
										}`}
									>
										<div className="h3 mb-1 font-weight-bold">{dashboard?.helpdesk || 0}</div>
										<div className="small h5">Help Desk</div>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Dashboard
